export default __webpack_public_path__ + "static/media/download (2).751bf2c0.jpg";